import { LANGUAGES, TUrl } from "./types";

export const DEFAULT_BASE_URL: TUrl = "https://production-central-backend-ne.beamimpact.com";

export const SUPPORTED_LANGUAGES: Record<string, LANGUAGES> = {
  en: "en",
  fr: "fr",
};
